import { useMemo } from 'react';

import type { UserResponse } from '~/lib/bff';
import type { LabelData } from '~/modules/artist-roster/types';

/*
  If filteredLabels is provided, it checks if the user has the target permission for every filtered label.
  Otherwise, it checks if the user has the target permission for every label in allLabels.
 */
export const useHasExportContactInfoPermission = (
  permissions: UserResponse['permissions'],
  filteredLabels: number[],
  allLabels?: LabelData[],
): boolean =>
  useMemo(() => {
    const hasPermission = (labelId: number) =>
      permissions?.[labelId.toString()]?.includes(
        'PARTY_CONTACT_INFO.EXPORT',
      ) ?? false;

    if (filteredLabels.length > 0) {
      return filteredLabels.some(hasPermission);
    }

    return allLabels?.some((label) => hasPermission(label.labelId)) ?? false;
  }, [filteredLabels, allLabels, permissions]);
